/** True when description HTML has visible text (ignores empty CKEditor placeholders). */
export function hasDisplayDescriptionContent(
  html: string | null | undefined
): boolean {
  const trimmed = html?.trim() ?? "";
  if (
    !trimmed ||
    trimmed === "<p></p>" ||
    trimmed === "<p>&nbsp;</p>" ||
    trimmed === "<p><br></p>"
  ) {
    return false;
  }

  const textOnly = trimmed
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/gi, " ")
    .trim();

  return textOnly.length > 0;
}
